import React from 'react';
import { Button, Modal, Icon } from 'semantic-ui-react';

import ContactForm from './ContactForm.js';

const ContactModal = () => (
    <Modal
        trigger={
            <Button primary animated="vertical" className="buttonFix">
                <Button.Content visible>
                    <Icon name="mail" />
                    Contact
                </Button.Content>
                <Button.Content hidden>
                    <Icon name="right arrow" />
                </Button.Content>
            </Button>
        }
        size="tiny"
        closeIcon={true}
        style={{ marginTop: 0 }}
    >
        <Modal.Header>Contact me</Modal.Header>
        <Modal.Content>
            <Modal.Description>
                <ContactForm />
            </Modal.Description>
        </Modal.Content>
    </Modal>
);

export default ContactModal;



// WEBPACK FOOTER //
// ./src/components/ContactModal.js